/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-29 20:05:55
 * @Description: 
 */

import { message } from "antd";
import { configure, observable } from "mobx";
import FTAnalytic from "src/analyze/FTAnalytic";
import ImageProcessor from "src/ImageProcessor";
import { FTGetAiArtImage, FTGetLoop, loadEffectList } from "src/server/api";
import utils, { cloneCanvas, createRecaptcha, FTGetLocalData, FTSaveLocalData, getUploadUrl, hanldelFTUserProfile, recaptchaReady, renderRecaptcha, uploadS3File } from "src/utils";
import FTLang from "src/utils/FTLang";
import FTCanvasStore from "./FTCanvasStore";
import { FTImageStoreType, UsedEffect } from "./types";
import packageConfig from "../../package.json"
import FTUserStore from "./FTUserStore";
// mobx 配置
configure({
  enforceActions: "never" // 允许直接修改状态
});

const FTImageStore = observable.object<FTImageStoreType>({
  currentImage: null,
  usedEffect: {},
  acturalSize: {
    width: 0,
    height: 0
  },
  currentSize: {
    width: 0,
    height: 0
  },
  prevEffect: null,
  greyImageElement: null,
  effectList: [],
  currentEffect: null,
  defaultEffect: "",
  imageElement: null, // 当前图片元素
  effectElement: null, // 特效生成的图片元素
  effectClassifyMap: [],
  intensity: {
    max: 100,
    min: 0,
    default: 100
  },
  defaultEffectClassify: "",
  currentIntensity: 50,
  loading: false,
  effectClassify: ["Sketch", "Cartoon", "Pixel","Watercolor", "Artist", "Art Genre", "Universal"],
  choicenessList: [],
  effectTags: [
    "Monochrome",
    "Colorful",
    "Bright",
    "Dark",
    "Saturated",
    "Faded",
    "Blue",
    "Red",
    "Green",
    "Yellow",
    "Gray",
    "White",
    "Pink",
    "Orange",
    "Lines",
    "Dotted",
    "Blocks",
    "Textured",
    "Retro",
    "Pop",
  ],
  selectEffectTags: [],
  searchText: "",
  searchList: [],
  imageHD: false,
  currentEffectType: "choiceness",
  uploadImageUrl:null,
  checkRoot:{load:false,token:null,need:false,id:null},
  changeCurrentIntensity(value: number) {
    this.currentIntensity = value
    FTCanvasStore.draw()
  },
  handelError(){
    this.loading = false
    this.currentEffect = this.prevEffect
    message.error(FTLang._("goart_effect_use_error"))
  },
  LoopExecute(id:string,effect:any){
//0排队 1成功 2失败 3超时 /4生成中
 const statusType = {
	connectionTimeout: 3,
	pending: 0,
	fail: 2,
	making: 4,
	success: 1,
  };

  FTGetLoop(id).then((res:any)=>{
    if(res.code==='000'){
     if(res.data.status===statusType.pending||res.data.status===statusType.making){
       setTimeout(() => {
         this.LoopExecute(res.data.taskId,effect)
       }, 2000);
     }
     else{
       if(res.data.status===statusType.success){
         let img = document.createElement('img');
         img.setAttribute("crossOrigin",'Anonymous')
         img.onload = ()=> {
           this.setUsedEffect({
             effect,
             target: img
           })
           this.loading = false
         }
         img.src =  res.data.resultImg;
       }
       else{
     // TODO: 报错提示
    this.handelError()
       }
     }
    }
   }).catch(error=>{
    this.handelError()
   })

  },
  async getAigcEffect(effect:any,tokens='',checkBox=false){
    this.loading = true
    let token=tokens
    this.currentEffect = effect
    // 获取上传链接
		try{
      if(!this.uploadImageUrl){
        let uploadUrls = await getUploadUrl();
        let { uploadUrl, key } = uploadUrls;
        let result:File=await new Promise((resolve)=>{
          (this.imageElement as HTMLCanvasElement).toBlob((blob:Blob|null)=>{
            let files=new File([blob as Blob],this.currentImage.name)
            resolve(files)
          },this.currentImage.type)
        })
         await uploadS3File(uploadUrl,result!);
         this.uploadImageUrl=key
      }

      if(!this.checkRoot.load){
        await createRecaptcha()
        this.checkRoot.load=true
      }
      if(!checkBox){
        token=await recaptchaReady('aigc_check')
      }

      let result=await FTGetAiArtImage({
        img:this.uploadImageUrl as string,
        templateId:process.env.REACT_APP_ENVIRONMENT === "production"?effect.prodId:effect.id,
        googleToken:token,
        googleAction:checkBox?'':'aigc_check'
      })
   //处理code
      if(result.code==='000'){
        this.LoopExecute(result.data.taskId,effect)
      }
      else if(result.code==='831'){
        this.checkRoot={...this.checkRoot,need:true}
        this.loading = false
        if(this.checkRoot.id!==null){
				  (window as any).grecaptcha.enterprise.reset(this.checkRoot.id)
				}
        else{
          this.rootExeCute()
        }
      }
      else if(result.code==='504'){
        this.loading = false
        if(!FTUserStore.userInfo){
          FTUserStore.showLogin({
            isSignIn: false,
            options: {
              position: "goart_download_fullsize"
            },
            isShowScenses: true,
            otherParam: {
              scenesId: "010",
              width: FTImageStore.currentSize.width,
              height: FTImageStore.currentSize.height,
              imgSrc: FTCanvasStore.canvas!.toDataURL("image/jpeg")
            },
            callback: () => {
              this.getAigcEffect(effect)
            },
            errorCallBack:()=>{
              this.currentEffect = this.prevEffect
            }
          })
          return
        }
        if(FTUserStore.isSvip){
          this.currentEffect = this.prevEffect
          message.error(FTLang._('goart_aigc_root_maxs'))
        }
        else{
          FTUserStore.showPaymnet({
            vipType: "vip",
            position: "goart_download_hd",
            otherParam: {
              scenesId: "012"
            },
            callback: () => {
              this.getAigcEffect(effect)
            },
            errorCallBack:()=>{
              this.currentEffect = this.prevEffect
            }
          })
        }

      }
      else{
        this.handelError()
      }
    }
    catch(error){
      this.handelError()
    }
  },
  rootExeCute(){
    this.checkRoot.id=renderRecaptcha('goart_content-root_fra',(token:string)=>{
      this.checkRoot={...this.checkRoot,need:false}
      this.getAigcEffect(this.currentEffect,token,true)
    })
  },
  async getGoartEffect(effect: any) {
    this.prevEffect = this.currentEffect
    if(effect?.aigc){
      if(this.usedEffect[effect.name]) {
        this.currentEffect = effect
        this.effectElement =this.usedEffect[effect.name]
        this.currentIntensity = effect.blend * 100
        FTCanvasStore.draw()
        this.loading = false
        return
      }
      this.getAigcEffect(effect)
      return
    }
    if(effect.name === "Original") {
      this.currentEffect = effect
      this.effectElement = null
      FTCanvasStore.draw()
    } else {
      this.loading = true
      this.currentEffect = effect
      if(this.usedEffect[effect.name]) {
        this.effectElement =this.usedEffect[effect.name]
        this.currentIntensity = effect.blend * 100
        FTCanvasStore.draw()
        this.loading = false
      } else {
        ImageProcessor.process(this.imageElement!, effect.id).then(async res => {
          if(effect.isgrey) {
            this.greyImageElement = await ImageProcessor.PreProcessGray(this.imageElement!)
          }
          this.setUsedEffect({
            effect,
            target: res
          })
          this.loading = false
        }).catch(err => {
          this.handelError()
        }).finally(() => {
          this.loading = false
        });
      }
    }
  },
  setCurrentImage(target: any) {
    this.currentImage = target
    this.reset()
  },

  setEffectList(list: any) {
    this.effectList = list.map((item: any) => {
      item.url = `${item.url}?v=${packageConfig.version}`
      return item
    })
    this.choicenessList = JSON.parse(JSON.stringify(this.effectList.filter((item: any) => item.choiceness)))
    this.effectClassifyMap = this.effectClassify.map((item: any, index) => {
      return {
        title: item,
        list: [],
        collapse: false || this.defaultEffectClassify === item
      }
    })
    for(let i = 0; i < this.effectList.length; i++) {
      let effect = this.effectList[i]
      let firstCategory = effect.firstCategory
      for(let j = 0; j < this.effectClassifyMap.length; j++) {
        if(this.effectClassifyMap[j].title === firstCategory) {
          this.effectClassifyMap[j].list.push(effect)
          if(this.defaultEffect === effect.id) {
            this.defaultEffectClassify = firstCategory
            this.effectClassifyMap[j].collapse = true
          }
        }
      }
    }
    // 只針對第一次進來的用戶才會默認使用推介第一個特效
    if(!this.defaultEffect) {
      let firstEntry = FTGetLocalData("fotor_goart_first_entry")
      if(!firstEntry) {
        this.defaultEffect = this.choicenessList[0]
        FTSaveLocalData("fotor_goart_first_entry", true)
      }
    }
  },

  setCurrentImageElement(target: HTMLCanvasElement, currentSize, acturalSize) {
    this.imageElement = target
    this.currentSize = currentSize
    this.acturalSize = acturalSize
    this.effectElement = null
    if(!FTCanvasStore.compareCanvas) {
      FTCanvasStore.compareCanvas = cloneCanvas(target)
      FTCanvasStore.compareCanvas.style.display = "none"
    }
    FTCanvasStore.draw()
  },

  setUsedEffect(data: UsedEffect) {
    this.effectElement = data.target
    this.currentIntensity = data.effect.blend * 100
    this.usedEffect[data.effect.name] = data.target
    window.dispatchEvent(new Event("resize"))
    FTCanvasStore.draw()
  },
  checkUsedEffect(effect: string) {
    return !!this.usedEffect[effect]
  },
  reset() {
    this.usedEffect = {}
    this.effectElement = null
  },
  getEffectIndex() {
    return this.effectList.indexOf(this.currentEffect)
  },
  hasPrev() {
    if(!this.currentEffect) return false
    if(this.currentEffect.name === "Original") {
      return false
    }
    let index = this.getEffectIndex()
    return index > 0
  },
  hasNext() {
    if(!this.currentEffect) return false
    if(this.currentEffect.name === "Original") return true
    let index = this.getEffectIndex()
    return index < this.effectList.length - 1
  },
  next() {
    if(this.hasNext() && !this.loading) {
      let index = this.getEffectIndex()
      let newEffect = this.effectList[++index]
      this.getGoartEffect(newEffect)
    }
  },
  prev() {
    if(this.hasPrev() && !this.loading) {
      let index = this.getEffectIndex()
      let newEffect = this.effectList[--index]
      this.getGoartEffect(newEffect)
    }
  },

  getEffectList() {
    loadEffectList({url: `/json/effect/AIEffectConfig_v2.json?v=${packageConfig.version}`}).then(res => {
      const list=res.list
      res.list=list.map((item:any)=>{
        if(item?.aigc){
          return {...item,id:process.env.REACT_APP_ENVIRONMENT === "production"?item.prodId:item.id}
        }
        return {...item}
      })
      this.effectClassify = res.classify || this.effectClassify;
      this.effectTags = res.tags || this.effectTags;
      this.setEffectList(res.list)
    })
  },

  async uploadImage(position: string,file?:File|null) {
    let img:Array<File>;
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$show$goart_import_image',
      label: {
        position: position
      }
    })
    if(file){
      img=[file as File]
    }
    else{
      img = await utils.selectImageFile({multiple: false})
    }
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$close$goart_import_image',
      label: {
        position: position
      }
    })
    if(img && img.length > 0) {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_import_image',
        label: {
          position: position,
          is_success: true
        }
      })
      hanldelFTUserProfile()
      FTCanvasStore.changeLoading(true)
      if(!utils.checkFileType(img[0])) {
        message.error(FTLang._("goart_image_upload_errror"))
        FTCanvasStore.changeLoading(false)
        return
      }
      let {canvas: imageElement, acturalSize, currentSize} = await utils.getImageFromFile(img[0]);
      this.setCurrentImageElement(imageElement, currentSize, acturalSize)
      this.setCurrentImage(img[0])
      window.dispatchEvent(new Event("resize"))
      FTCanvasStore.changeLoading(false)
      if(this.currentEffect && this.currentEffect !== "original") {
        FTAnalytic.addAnalytic({
          type: 'ev',
          analyticType: "sa",
          action: 'fotor_web$click_up$goart_project_effects',
          label: {
            resource_id: utils.toFixed(this.currentEffect.id, 0),
            resource_name: this.currentEffect.name,
          }
        })
        this.getGoartEffect(this.currentEffect)
      } else {
        // let effect = undefined
        // if(Object.prototype.toString.call(this.defaultEffect) === "[object Object]") {
        //   effect = this.defaultEffect
        // } else if(Object.prototype.toString.call(this.defaultEffect) === "[object Number]") {
        //   this.effectClassifyMap = this.effectClassifyMap.map((item: any) => {
        //     if(item.list.some((ite: any) => {
        //       if(ite.id === this.defaultEffect) {
        //         effect = ite
        //         return true
        //       }
        //       return  false
        //     })) {
        //       item.collapse = true
        //     }
        //     return item
        //   })
        // }
        
        // effect && FTAnalytic.addAnalytic({
        //   type: 'ev',
        //   analyticType: "sa",
        //   action: 'fotor_web$click_up$goart_project_effects',
        //   label: {
        //     resource_id: utils.toFixed(effect.id, 0),
        //     resource_name: effect.name,
        //   }
        // })
        // effect && this.getGoartEffect(effect)
      }
    } else {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_import_image',
        label: {
          position: position,
          is_success: false
        }
      })
    }
  },
  addSelectTags(tag) {
    let index = this.selectEffectTags.indexOf(tag)
    if(index === -1) {
      this.selectEffectTags = [...this.selectEffectTags, tag]
    } else {
      this.selectEffectTags.splice(index, 1)
      this.selectEffectTags = [...this.selectEffectTags]
    }
    this.searchText = this.selectEffectTags.map(item => `#${item}`).join(" ")
    if(this.selectEffectTags.length) {
      // 执行搜索操作
      this.search()
    } else {
      // 显示分类
      this.searchList = []
    }

  },
  clearSelectTags() {
    this.selectEffectTags = []
  },
  search() {
    // 支持使用 数字 空格和逗号（英文）进行搜索
    let searchText = this.searchText.replace(/[^\w| |,]/g, () => "").split(/[ |,]/).filter(item => item).map(item => item.toLocaleLowerCase())
    let searchList = new Set()
    let precisionList = new Set()
    if(this.selectEffectTags.length) {
      searchText = this.selectEffectTags.slice().map(item => item && item.toLocaleLowerCase())
      for(let j = 0; j < this.effectList.length; j++) {
        let effect = this.effectList[j]
        let secondCategory = effect.secondCategory.toLocaleLowerCase().split(/[ |,]/g).filter((item: any) => item)
        if(searchText.every((item: any) => secondCategory.some((ite: any) => item === ite))) {
          searchList.add(effect)
        }
      }
    } else {
      for(let i = 0; i < searchText.length; i++) {
        let text = searchText[i]
        for(let j = 0; j < this.effectList.length; j++) {
          let effect = this.effectList[j]
          if(effect.name.toLocaleLowerCase() === text) {
            precisionList.add(effect)
          } else if(effect.name.toLocaleLowerCase().startsWith(text)) {
            searchList.add(effect)
          }
          if(effect.firstCategory.toLocaleLowerCase().startsWith(text)) {
            searchList.add(effect)
          }
          if(effect.secondCategory.toLocaleLowerCase().split(/[ |,]/g).filter((item: any) => item).some((item: any) => item.startsWith(text))) {
            searchList.add(effect)
          }
        }
      }

    }
    // 如果使用 array.from, 会使数据失去连通性
    for (let item of searchList.values()) {
      precisionList.add(item)
    };
    this.searchList = []
    for (let item of precisionList.values()) {
      this.searchList.push(item)
    };

    const computedSearchNumber = (length: number) => {
      if(length === 0) {
        return "0"
      } else if(length > 0 && length <= 10) {
        return "1-10"
      } else if(length > 11 && length <= 20) {
        return "11-20"
      } else if(length > 21 && length <= 30) {
        return "21-30"
      } else if(length > 31 && length <= 40) {
        return "31-40"
      } else {
        return "41以上"
      }
    } 
    // FTAnalytic.addAnalytic({
    //   type: 'ev',
    //   analyticType: "sa",
    //   action: 'fotor_web$search$goart_project',
    //   label: {
    //     boolean1: this.searchList.length === 0,
    //     string1: computedSearchNumber(this.searchList.length),
    //   }
    // })
  }
})

export default FTImageStore